import { render, staticRenderFns } from "./jor_18bar.vue?vue&type=template&id=764d79a9&"
import script from "./jor_18bar.vue?vue&type=script&lang=js&"
export * from "./jor_18bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports